export function getNavFor(user) {
  if (!user) return [];
  if (user.role === "super_admin") {
    return [
      { key: "search", to: "/search", label: "Dispenser Search" },
      { key: "users", to: "/admin", label: "Users & Branches" },
      { key: "resources", to: "/hod", label: "Resources & Rules" },
      { key: "knowledge", to: "/knowledge", label: "Knowledge Bank" },
      { key: "roles", to: "/roles", label: "Roles Tracker" },
      { key: "analytics", to: "/analytics", label: "Analytics" },
      { key: "activity", to: "/activity", label: "Activity Log" },
    ];
  }
  if (user.role === "hod") {
    const perms = user.permissions || [];
    const nav = [];
    if (perms.includes("manage_resources") || perms.includes("manage_web_sources") || perms.includes("manage_rules"))
      nav.push({ key: "resources", to: "/hod", label: "Resources & Rules" });
    nav.push({ key: "knowledge", to: "/knowledge", label: "Knowledge Bank" });
    nav.push({ key: "roles", to: "/roles", label: "Roles Tracker" });
    if (perms.includes("view_analytics")) nav.push({ key: "analytics", to: "/analytics", label: "Analytics" });
    if (perms.includes("view_activity")) nav.push({ key: "activity", to: "/activity", label: "Activity Log" });
    return nav;
  }
  // dispenser
  return [
    { key: "search", to: "/search", label: "Dispenser Search" },
    { key: "resources-view", to: "/resources", label: "Resources" },
    { key: "roles", to: "/roles", label: "Roles Tracker" },
    { key: "knowledge", to: "/knowledge", label: "Knowledge Bank" },
  ];
}

export function landingFor(user) {
  if (!user) return "/login";
  if (user.role === "dispenser") return "/search";
  if (user.role === "hod") return "/hod";
  return "/admin";
}
